<div class="w-full space-y-4 border-b border-zinc-200 pb-6 dark:border-zinc-800">
  <div>
    <h4 class="text-sm font-semibold text-primary">Creator payment details</h4>
    <p class="mt-1 text-xs text-secondary">
      Load <code class="text-primary">creator_payment_detail</code> via GodMode admin API. Requires GodMode on your
      account.
    </p>
  </div>

  <div class="w-full max-w-xl space-y-1">
    @if (!settingsContext.hasCreatorId()) {
    <p class="text-sm text-amber-800 dark:text-amber-200" role="status">
      Enter creator Firebase UID in the context bar above, then load payment details.
    </p>
    }
  </div>

  <button
    type="button"
    class="rounded-lg border border-zinc-300 bg-white px-4 py-2 text-sm font-medium text-primary shadow-sm hover:bg-zinc-50 disabled:opacity-50 dark:border-zinc-600 dark:bg-zinc-900 dark:hover:bg-zinc-800"
    (click)="loadDetails()"
    [disabled]="loadLoading() || !settingsContext.hasCreatorId()"
  >
    @if (loadLoading()) {
      Loading…
    } @else {
      Load payment details
    }
  </button>

  @if (loadError()) {
  <p class="text-sm text-red-600 dark:text-red-400" role="alert">{{ loadError() }}</p>
  }

  @if (items().length) {
  <ol class="w-full space-y-2" aria-label="Creator payment detail checks">
    @for (item of items(); track item.key) {
    <li class="rounded-lg border border-zinc-200 px-3 py-2.5 dark:border-zinc-800">
      <div class="flex flex-row items-start gap-3">
        <span
          class="mt-0.5 inline-flex size-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold"
          [class]="iconClass(item.state)"
          aria-hidden="true"
        >
          @switch (item.state) {
          @case ('ok') { ✓ }
          @case ('missing') { × }
          @case ('error') { × }
          @case ('loading') { … }
          @default { · }
          }
        </span>
        <div class="min-w-0 flex-1">
          <div class="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
            <span class="text-sm font-medium text-primary">{{ item.label }}</span>
          </div>
          <p class="mt-1 font-mono text-xs break-all text-secondary">{{ item.detail }}</p>
        </div>
      </div>
    </li>
    }
  </ol>
  }
</div>
